import { lazy } from "react";
import Loadable from "app/components/Loadable";
import Reports from "../reports";

const reports = Loadable(lazy(() => import("../reports")));

const ReportsRoute = [{ path: "/reports", element: <Reports /> }];
export default ReportsRoute;